/*global ViewController, WebView, moment*/
var secondScreenPdfViewerController = new ViewController(
    {
        directory: "views/attach",
        name: "secondScreenPdfViewer",
        container: "main",
        route: "second-screen-pdf",
    }
);

//handle the opening parameters
secondScreenPdfViewerController.prepareDataOnEnter = async function(data, callback){
    window.addEventListener("message", async (e) => {
        let newAttach = null;
        try {
            newAttach = JSON.parse(e.data);
        } catch (e) {
            console.log(e);
        }
        if(newAttach && newAttach.id && newAttach.id !== data.attach.id){
            this.updateRouteData('second-screen-pdf',{ attach:{id: newAttach.id} });
        }
    }, false);

    if(data.attach && data.attach.id){
        let reads = await window.app.context.apip.db.multiread({
            ir_attachment: {
                searchFirst: { id: data.attach.id }
            }
        });
        let attach = reads.ir_attachment;
        await this.preparePdfUrl(attach);
        data.attach.pdfUrl = attach.pdfUrl;
    }
    callback(null,{
        attach: data.attach
    }) ;
} ;



module.exports = secondScreenPdfViewerController ;